import { useEffect, useRef, useState } from 'react'
import { ConvertPriceToString } from '../../../../Helpers/CustomConverter'
import { useOffers } from '../../../../Providers/OffersProvider'
import { useCart } from '../../../../Providers/CartProvider'
import useGetProductPrices from '../../../../Components/BasketPage/Hooks/useGetProductPrices'
import { useParams } from 'react-router-dom'
import { handleInputForQtyAndValueFocus, handleInputKeyPressForQtyAndValueInput } from '../../../../Helpers/PriceAndValueInputHelpers'
import { toast } from 'react-toastify'
import useCommonFunctions from '../../Hooks/MobileAndDesktopCommon/useCommonFunctions'

const ProductBuyBtnForRealizedOffer = ({ product }) => {
    const inputRef = useRef(null)
    const { orderItemsFromOffer, setOrderItemsFromOffer, getProductQuantityInRealizedOffer } = useOffers()
    const lastValidQuantity = useRef(getProductQuantityInRealizedOffer(product))
    const { getGrossValue, round2 } = useCart()
    const { isMobile } = useParams()
    const { priceNet } = useGetProductPrices(product)
    const { checkIfProductCanBeAddedWithQuantity } = useCommonFunctions()

    const [priceNetTotal, setPriceNetTotal] = useState(0)
    const [priceGrossTotal, setPriceGrossTotal] = useState(0)
    const [quantity, setQuantity] = useState(getProductQuantityInRealizedOffer(product))

    const stepValue = product.salesRatio && product.salesRatio > 0 ? product.salesRatio : 1
    const totalNet = ConvertPriceToString(priceNetTotal, product.currency)
    const totalGross = ConvertPriceToString(priceGrossTotal, product.currency)
    const decimalPlaces = product.decimalPlaces

    useEffect(() => {
        if (quantity === '') {
            return
        }
        else if (Number(quantity) === 0) {
            setOrderItemsFromOffer(prevItems =>
                prevItems.filter(item => item.product.orderPosition !== product.orderPosition))
            return
        }
        if (priceNet !== undefined && priceNet !== null) {
            calculateGrosNetPrice()
        }
    }, [quantity, priceNet])

    const handleInputOnChange = (e) => {
        let value = e.target.value
        if (value > product.maxQtyToOrder) {
            toast.warning('Nie możesz zamówic wiekszej ilości, niż ilośc w ofercie!')
            return
        }
        // if (!checkIfProductCanBeAddedWithQuantity(value, product)) { Do zastanowienia się jak to rozwiązać na ofercie!
        //     return
        // }   
        setQuantity(value)

        if (value !== '') {
            lastValidQuantity.current = value  //aktualizuj tylko gdy nie pusty
            setOrderItemsFromOffer(prevItems =>
                prevItems.map((item) =>
                    item.product.orderPosition === product.orderPosition ? { ...item, qty: value } : item))
        }
    }

    const handleInputKeyPress = (event) => {
        if (!handleInputKeyPressForQtyAndValueInput(event, decimalPlaces)) {
            event.preventDefault()
            return
        }
    }

    const handleInputLostFocus = (e) => {
        const raw = e.target.value.trim()

        if (raw === '') {
            setQuantity(lastValidQuantity.current)
            return
        }

        const parsed = round2(parseFloat(raw))
        lastValidQuantity.current = parsed
        setQuantity(parsed)
    }

    const calculateGrosNetPrice = () => {
        if (quantity === 0) {
            const tmpSaleRatio = product.salesRatio > 0 ? product.salesRatio : 1
            setPriceNetTotal(round2(tmpSaleRatio * parseFloat(priceNet)))
            setPriceGrossTotal(round2(getGrossValue(priceNet, tmpSaleRatio, product.taxRate)))
        }
        else {
            const netValue = quantity * parseFloat(priceNet)
            let grossValue = getGrossValue(priceNet, quantity, product.taxRate)
            setPriceNetTotal(round2(netValue))
            setPriceGrossTotal(round2(grossValue))
        }
    }

    const handleOnKeyDown = (e) => {
        if (isMobile) {
            if (['Enter', 'Go', 'Done', 'Next', 'Send', "Tab"].includes(e.key)) {
                e.preventDefault()
                setQuantity(e.target.value)
                setOrderItemsFromOffer(prevItems =>
                    prevItems.map((item) =>
                        item.product.orderPosition === product.orderPosition ? { ...item, qty: e.target.value } : item
                    )
                )
                return
            }
        }
        else if (e.key === 'Enter') {
            setQuantity(e.target.value)
            setOrderItemsFromOffer(prevItems =>
                prevItems.map((item) =>
                    item.product.orderPosition === product.orderPosition ? { ...item, qty: e.target.value } : item
                )
            )
        }
    }

    return (
        <div className='d-flex flex-column align-items-end'>
            <input type='number' className='biggerArrows quantity-input' value={quantity} style={{ maxWidth: '60%' }}
                onChange={(e) => handleInputOnChange(e)} onKeyPress={(e) => handleInputKeyPress(e)} onFocus={handleInputForQtyAndValueFocus}
                onKeyDown={handleOnKeyDown} onBlur={handleInputLostFocus} step={stepValue} ref={inputRef} min={0} max={99999} />

            <div className={`me-2`}>
                <div className='d-flex flex-column align-items-end'>
                    <b>{`Razem: ${totalNet}`}</b>
                    <span className='light-text-color'>{`${totalGross} brutto (${product.taxRate}%)`}</span>
                </div>
            </div>
        </div>
    )
}

export default ProductBuyBtnForRealizedOffer